export function redirectPathForRole(role) {
  if (role === 'SUPERADMIN') return '/merchant'
  if (role === 'ASSOCIATION') return '/association'
  if (role === 'COMMERCANT') return '/commerce-dashboard'
  if (role === 'PRESTATAIRE') return '/prestataire-dashboard'
  return '/'
}
